import SideMenu from '@/containers/side-menu/SideMenu.vue';
import VehiclePixBuying from '@/pages/vehicle-pix-buying/VehiclePixBuying';

export default {
  path: '/vehicle-pix-buying',
  name: 'VehiclePixBuying',
  components: {
    mainContent: VehiclePixBuying,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'vehicle-pix-transactions',
    },
    breadcrumb: {
      title: 'Pix Comprados',
      paths: [
        { title: 'Veículo' },
        { title: 'Pix Comprados' },
      ],
    },
  },
};
